module.exports = __webpack_public_path__ + "static/media/perfectDark.c7532aad.wav";